// Supabase's email enumeration protection answers signUp() for an address that
// already has a confirmed account with a 200 and an obfuscated user object — no
// error, no email sent. The obfuscated user has a random id and an empty
// `identities` array; a genuine new signup (or a re-signup of an unconfirmed
// account, which does resend the confirmation) always carries one identity.
// Without this check the form shows "check your email" for a mail that never
// comes (2026-09-14, a returning contractor signed up again and waited).
export function isRepeatedSignup(
  user: { identities?: unknown[] | null } | null | undefined
): boolean {
  return !!user && Array.isArray(user.identities) && user.identities.length === 0;
}
